<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
// Components
import SharedElementPagination from "@/components/shared/SharedElementPagination.vue";
import SharedDeleteConfirmDialog from "@/components/shared/SharedDeleteConfirmDialog.vue";
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import { useAutomaticSearch } from "@/app/composables/useAutomaticSearch";

// Services
// Services
import ResourceService from '@/api/services/resource.service';
import Notification from '@/utils/plugins/NotificationService';

import { getCurrentInstance, onMounted, ref } from "vue";
import { useUiStore } from "@/app/stores/uiStore";


const uiStore = useUiStore();

const instance = getCurrentInstance();

const leaveTypes = ref([]);

const leaveType = ref({});

const submitted = ref(false);

const selectedLeaveType = ref(null);

const page = ref(1);

const itemsPerPage = ref(10);

const totalResults = ref(0);

const leaveTypeName = ref('');

const leaveTypeObservations = ref('');

const deleteDialogShown = ref(false);

const createOrUpdateLeaveType = ref(false);

const searchFilterLeaveTypeName = ref('');
const { beginRequest, isCurrentRequest } = useAutomaticSearch(searchFilterLeaveTypeName, () => {
  page.value = 1;
  getLeaveTypes();
});

function notEmptyObject(someObject) {
  return Object.keys(someObject).length;
}

function editLeaveType(leaveType) {
  selectedLeaveType.value = leaveType;
  leaveTypeName.value = leaveType.name;
  leaveTypeObservations.value = leaveType.observations;
  createOrUpdateLeaveType.value = true;
}

function handleUpdateDepartment() {
  selectedLeaveType.value.name = leaveTypeName.value;
  updateLeaveType(selectedLeaveType.value);
}

function getLeaveTypes(searchQuery = searchFilterLeaveTypeName.value) {
  const params = {
    page: page.value,
    itemsPerPage: itemsPerPage.value
  };
  if (searchQuery) {
    params.name = searchQuery;
  }
  uiStore.startLoading();
  const requestId = beginRequest();
  ResourceService.getLeaveTypes(params)
    .then(res => {
      if (!isCurrentRequest(requestId)) return;
      leaveTypes.value = res.data['hydra:member'];
      totalResults.value = res.data['hydra:totalItems'];
    })
    .finally(() => {
      uiStore.stopLoading();
    });
}

function createLeaveType(leaveType) {
  leaveType.name = leaveTypeName.value;
  leaveType.observations = leaveTypeObservations.value;
  // this.$uiStore.setLoading(true);
  uiStore.startLoading();
  ResourceService.createLeaveType(leaveType).then(() => {
    Notification.addNotification('Tipo de baja creada correctamente', 'success', 6000);
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
    cancel();
  }).catch(() => {
    Notification.addNotification('Error al crear tipo de baja', 'error', 6000);
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
  }).finally(() => {
    closeCreateOrUpdateDialog();
  });
}

function updateLeaveType(selectedLeaveType) {
  if (leaveTypeName.value) {
    selectedLeaveType.name = leaveTypeName.value;
  }
  selectedLeaveType.observations = leaveTypeObservations.value;

  // this.$uiStore.setLoading(true);
  uiStore.startLoading();
  ResourceService.updateLeaveType(selectedLeaveType, selectedLeaveType.id).then(() => {
    Notification.addNotification('Tipo de baja actualizado correctamente', 'success', 6000);
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
    cancel();
  }).catch(() => {
    Notification.addNotification('Error al actualizar el tipo de baja', 'error', 6000);
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
  }).finally(() => {
    closeCreateOrUpdateDialog();
  });
}

function deleteLeaveType(leaveType) {
  ResourceService.deleteLeaveType(leaveType.id).then(() => {
    Notification.addNotification('Tipo de baja eliminado correctamente.', 'success', 6000);
    deleteDialogShown.value = false;
    cancel();
  }).catch(() => {
    Notification.addNotification('Error al eliminar el tipo de baja seleccionado', 'error', 6000);
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
  });
}

function reset() {
  leaveType.value = {};
  leaveTypeName.value = '';
  leaveTypeObservations.value = '';
  selectedLeaveType.value = null;
}

function cancel() {
  reset();
  getLeaveTypes();
}

function closeCreateOrUpdateDialog() {
  createOrUpdateLeaveType.value = false;
  reset();
}

onMounted(() => {
  getLeaveTypes();
});
</script>

<template>
  <div>
    <HeaderTitle title="Ajustes" />
    <div class="d-flex flex-row justify-content-start">
      <img src="@/assets/icons/group.svg" width="30" alt="">
      <div class="title-text pl-4">
        Tipos de Baja
      </div>
    </div>
    <el-card
             class="card-search w-100 wback"
             body-style="padding:0"
             style="height: auto !important;"
    >
      <div class="row mx-5 master-search-row">
        <div class="col-12">
          <div class="row align-items-end">
            <div class="col-md-4 col-12">
              <div class="form-item date-picker label-common">
                <label class="w-100 mb-2">Tipo de baja</label>
                <el-input v-model="searchFilterLeaveTypeName" placeholder="Tipo de Baja" prefix-icon="el-icon-search" clearable />
              </div>
            </div>
            <div class="col-md-4 offset-md-4 col-12 d-flex justify-content-end master-search-actions">
              <button @click="createOrUpdateLeaveType = true" class="btn btn_darkpink btn-search master-create-button">
                NUEVO TIPO DE BAJA
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <div class="table table-not-mobile">
      <div v-if="leaveTypes && leaveTypes.length > 0">
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Observaciones</th>
              <th class="master-actions-col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="leaveType in leaveTypes"
              :key="leaveType.id"
              class="pointer"
              @click="editLeaveType(leaveType)"
            >
              <td>
                {{ leaveType.name }}
              </td>
              <td>{{ leaveType.observations }}</td>
              <td class="master-actions-col">
                <div class="buttons d-inline-flex">
                  <font-awesome-layers class="fa-2x pointer" style="margin-left: 5px" title="Editar"
                    @click.stop="editLeaveType(leaveType)">
                    <font-awesome-icon icon="circle" style="color: #f7d20e" />
                    <font-awesome-icon icon="plus" class="fa-inverse" transform="shrink-6" />
                  </font-awesome-layers>
                  <font-awesome-layers class="fa-2x pointer" style="margin-left: 5px" title="Eliminar"
                    @click.stop="deleteDialogShown = true; selectedLeaveType = leaveType;">
                    <font-awesome-icon icon="circle" style="color:red" />
                    <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
                  </font-awesome-layers>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <h5>No se han encontrado tipos de baja laboral</h5>
      </div>
    </div>

    <div class="table-mobile">
      <div v-if="leaveTypes && leaveTypes.length > 0">
        <el-row v-for="leaveType in leaveTypes" :key="leaveType.id" class="mt-3">
          <el-card class="master-mobile-card w-100 pointer" @click="editLeaveType(leaveType)">
            <div class="master-mobile-card__delete">
              <font-awesome-layers class="fa-2x pointer" title="Eliminar" @click.stop="deleteDialogShown = true; selectedLeaveType = leaveType;">
                <font-awesome-icon icon="circle" style="color:red" />
                <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
              </font-awesome-layers>
            </div>
            <div class="master-mobile-card__title">{{ leaveType.name }}</div>
            <div class="master-mobile-card__item">
              <span class="master-mobile-card__label">Observaciones:</span>
              <span>{{ leaveType.observations || '--' }}</span>
            </div>
          </el-card>
        </el-row>
      </div>
      <div v-else class="mt-3">
        <h5>No se han encontrado tipos de baja laboral</h5>
      </div>
    </div>

    <SharedElementPagination
      class="pagination"
      v-model:current-page="page"
      :total="totalResults"
      v-model:page-size="itemsPerPage"
      style="padding: 0px 0px 20px 0px;"
      @change="page = $event; getLeaveTypes(searchFilterLeaveTypeName)" show-always />

    <el-dialog
        v-model="createOrUpdateLeaveType"
        class="dense-dialog leave-type-dialog"
        @closed="closeCreateOrUpdateDialog()"
        :show-close="false"
        size="'medium'"
        width="750"
        :center="true"
        :lock-scroll="true"
        :style="{ borderRadius: `var(--el-border-radius-round)` }"
        >
        <div class="my-header">
        <svg
            id="asterisk"
            xmlns="http://www.w3.org/2000/svg"
            width="724"
            height="1024"
            viewBox="0 0 724 1024"
        >
          <path
              d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z"
          />
        </svg>
        <span class="text-header ml-5 mt-3">{{ selectedLeaveType ? 'Actualizar' : 'Nuevo'}} Tipo de Baja</span>

        <img
            class="close-icon pointer"
            src="@/assets/images/aspa_blue_small_entrada.png"
            alt=""
            @click="closeCreateOrUpdateDialog()"
        >
      </div>
      <div class="my-body">
        <form @submit.prevent="">
          <div class="row">
            <div class="col-12">
              <label for="leaveTypeName" class="w-100">Tipo de Baja</label>
              <el-input
                  v-model="leaveTypeName"
                  :placeholder="'Tipo de Baja'"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 form-item">
              <label class="w-100">Motivo de la baja</label>
              <textarea
                  rows="8"
                  class="w-100 p-2"
                  v-model="leaveTypeObservations"
                  :placeholder="'Motivo de la baja'"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 offset-md-8 col-12 d-flex flex-column justify-content-end align-items-end master-dialog-actions">
              <button
                  class="btn btn_darkpink"
                  @click="selectedLeaveType ? handleUpdateDepartment() : createLeaveType(leaveType)"
              >
                {{ selectedLeaveType ? 'Actualizar' : 'Nuevo'}}
              </button>
            </div>
          </div>
        </form>
      </div>
    </el-dialog>

    <SharedDeleteConfirmDialog
      v-model="deleteDialogShown"
      title="Eliminar tipo de baja"
      message="¿Desea eliminar permanentemente este tipo de baja?"
      @confirm="deleteLeaveType(selectedLeaveType)"
      @cancel="selectedLeaveType = null"
    />
  </div>
</template>

<style lang="scss" scoped>
.my-body.my-body { margin-right: 0; }
.master-search-row .form-item { margin-bottom: 0; }
.master-create-button { width: 100%; max-width: 300px; min-height: 44px; margin-bottom: 0 !important; color: white; }
@media (max-width: 767px) { .master-search-row .form-item { margin-bottom: 12px; } }

.leave-type-input {
  /*display: flex;*/
  vertical-align: baseline;
  margin: 30px 10px 10px 10px;
}

.table-leave-types {
  table {
    //margin-left: auto;
    //margin-right: auto;
    //width: auto;
  }
}


.el-dialog__body {
  background: #f3f0fb !important;
  min-height: 800px !important;

  .el-dialog__header {
    padding: 0;
  }

  .my-header {
    margin-top: 2px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .text-header {
      text-align: left;
      font-size: 4em;
      font-weight: 900;
      letter-spacing: -0.05em;
      color: #f9156f;
    }

    .close-icon {
      width: 8%;
      height: 20%;
    }

    .inter-icon {
      width: 2%;
      height: 2%;
    }

    #asterisk {
      position: absolute;
      vertical-align: super;
      height: auto;
      width: 2.2em;
      fill: #f9156f;
    }

  }

}

.table-mobile {
  display: none;
}

.master-mobile-card {
  border-radius: 16px;
}

.master-mobile-card :deep(.el-card__body) {
  position: relative;
  padding: 16px 18px;
}

.master-mobile-card__delete {
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 1;
}

.master-mobile-card__title {
  color: $bg-blue;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  margin-bottom: 10px;
  padding-right: 42px;
  word-break: break-word;
}

.master-mobile-card__item {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  word-break: break-word;
}

.master-mobile-card__label {
  color: $bg-blue;
  font-weight: 800;
}

.master-mobile-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
}

.master-actions-col {
  width: 110px;
  min-width: 110px;
  text-align: center;
}

@media (min-width: 768px) {
  .table-mobile {
    display: none;
  }
}

@media (max-width: 767px) {
  .title-text {
    font-size: 2.2em;
  }

  .card-search {
    padding: 20px 16px;
    background-size: 92px;
    background-position: calc(100% + 16px) 12px;
  }

  .master-search-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .master-search-actions {
    width: 100%;
    flex-direction: column;
    align-items: stretch !important;
    gap: 10px;
    margin-top: 10px;
  }

  .master-search-actions .btn-search {
    width: 100%;
    max-width: 100% !important;
    min-width: 100% !important;
  }

  .table-not-mobile {
    display: none;
  }

  .table-mobile {
    display: block;
    padding-right: 14px;
  }

  :deep(.leave-type-dialog) {
    width: calc(100vw - 24px) !important;
    max-width: calc(100vw - 24px);
    margin-top: 4vh !important;
  }

  :deep(.leave-type-dialog .el-dialog__body) {
    min-height: auto !important;
  }

  .el-dialog__body .my-header {
    align-items: flex-start;
    gap: 12px;
    padding-right: 10px;
  }

  .el-dialog__body .my-header .text-header {
    font-size: 2em;
    line-height: 1.1;
    margin-top: 0.75rem !important;
  }

  .el-dialog__body .my-header .close-icon {
    width: 26px;
    min-width: 26px;
    margin-top: 12px;
  }

  .el-dialog__body .my-body {
    margin-right: 0;
  }

  .master-dialog-actions {
    align-items: stretch !important;
    margin-left: 0 !important;
  }

  .master-dialog-actions .btn {
    width: 100%;
  }
}
</style>
